import { Outlet } from "react-router-dom";
import { Suspense, FC } from "react";
import Sidebar from "./_components/Sidebar";
import Header from "./_components/Header"; 

const DashboardLayout: FC = () => {
  return (
    <>
      
      <Header open={true} />

      <div className="flex">
        <Sidebar />
        <div className="flex-1 ml-16 lg:ml-20  pt-20 overflow-y-auto h-screen">
          <Suspense fallback={<div>Loading...</div>}>
            <div className="py-10 px-3 lg:px-4 pr-2">
              <Outlet />
            </div>
          </Suspense>
        </div>
      </div>
    </>
  );
};

export default DashboardLayout;
